export default "__VITE_ASSET__CZThEcJu__"